export const symbols = [
    {
        name: "S1",
        id: 10,
        size: { width: 1, height: 1 },
        weight: 0,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "BigCandySymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "BigCandySymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
        zIndex: 100,
    },
    {
        name: "S2",
        id: 9,
        size: { width: 1, height: 1 },
        weight: 30,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "HeartSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "HeartSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
    },
    {
        name: "S3",
        id: 8,
        size: { width: 1, height: 1 },
        weight: 30,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "CandyVioletSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "CandyVioletSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
    },
    {
        name: "S4",
        id: 7,
        size: { width: 1, height: 1 },
        weight: 30,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "CandyGreenSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "CandyGreenSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
    },
    {
        name: "S5",
        id: 6,
        size: { width: 1, height: 1 },
        weight: 20,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "BlueCandySymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "BlueCandySymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
    },
    {
        name: "S6",
        id: 5,
        size: { width: 1, height: 1 },
        weight: 20,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "AppleSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "AppleSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
        bg: null,
        frame: null,
    },

    {
        name: "S7",
        id: 4,
        size: { width: 1, height: 1 },
        weight: 20,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "PlumSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "PlumSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
        bg: null,
        frame: null,
    },

    {
        name: "S8",
        id: 3,
        size: { width: 1, height: 1 },
        weight: 20,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "WatermelonSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "WatermelonSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
        bg: null,
        frame: null,
    },
    {
        name: "S9",
        id: 2,
        size: { width: 1, height: 1 },
        weight: 1,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "GrapeSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "GrapeSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
        bg: null,
        frame: null,
    },
    {
        name: "S10",
        id: 1,
        size: { width: 1, height: 1 },
        weight: 1,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "BananaSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "BananaSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
        bg: null,
        frame: null,
    },
    {
        name: "S11",
        id: 11,
        size: { width: 1, height: 1 },
        weight: 0,
        noPay: true,
        isScatter: true,
        sprite: {
            anchor: { x: 0.5, y: 0.5 },
        },
        drop: {
            spine: "BombLargeSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "in",
        },
        win: {
            spine: "BombLargeSymbol",
            atlas: "EffectSymbolsAnimation",
            animation: "out",
        },
        zIndex: 99,
    }
];
